namespace Matrix.Indexation {
    export namespace FactIndexConstituentRorService {
        export const baseUrl = 'Indexation/FactIndexConstituentRor';

        export declare function Create(request: Serenity.SaveRequest<FactIndexConstituentRorRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FactIndexConstituentRorRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FactIndexConstituentRorRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FactIndexConstituentRorRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Indexation/FactIndexConstituentRor/Create",
            Update = "Indexation/FactIndexConstituentRor/Update",
            Delete = "Indexation/FactIndexConstituentRor/Delete",
            Retrieve = "Indexation/FactIndexConstituentRor/Retrieve",
            List = "Indexation/FactIndexConstituentRor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>FactIndexConstituentRorService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
